import { Controller } from 'stimulus'
import { AjaxHelper } from '~/common/extensions/ajax_helpers'
import { getCsrfParamsAsObject } from '~/common/helpers/csrf'

export default class extends Controller {
  static values = {
    url: String,
    participantTimeZone: String,
    customerTimeZone: String,
  }

  connect() {
    if (window.location.search.includes('mc_test')) {
      console.log(this.participantTimeZoneValue, this.customerTimeZoneValue)
    }
  }

  async rerenderTimes(e) {
    const val = e.target.value

    const response = await fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        time_zone: val,
        ...getCsrfParamsAsObject(),
      }),
    })

    const data = await response.json()
    AjaxHelper.doUpdate(data)
  }
}
